export default __webpack_public_path__ + "static/media/BH Icons 30 p_Check-In.dcf232f2.svg";